import type { FC } from 'react';

import { Box, Container, Typography } from '@mui/material';
import { Link } from 'react-router-dom';

type Props = {
  href: string;
};

export const SubscriptionHeader: FC<Props> = ({ href }) => {
  return (
    <Box
      className="group hidden h-10 w-full flex-nowrap items-center justify-center text-center text-white no-underline sm:flex"
      component={Link}
      sx={{
        backgroundImage: 'linear-gradient(90deg, #224185 0%, #254a9e 15%, #203565 50%, #2855bb 70%, #223c79 100%)',
      }}
      to={href}
    >
      <Container disableGutters className="relative h-full px-4" maxWidth="xl">
        <div className="flex h-full w-full items-center justify-center">
          <div className="flex items-center gap-2">
            <div className="mx-auto w-fit opacity-90 group-hover:opacity-100">
              Choose your plan to unlock instant access to Truv
            </div>

            <Typography className="text-white underline hover:text-white/80">Get started</Typography>
          </div>
        </div>
      </Container>
    </Box>
  );
};
